import React, { Suspense } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useNotificationBiString } from '../../utils/notificationToBiString';
import { renderNotification } from './renderNotification';
import s from './NCNotification.scss';
const NCNotification = ({ notification, isLoading, className })=>{
    const notificationBiString = useNotificationBiString(notification);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "NCNotification"
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            notification_message_id: notification.messageId,
            notification_type: notificationBiString
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(isLoading && s['loading'], className),
        "data-nc": `${notification.bucket}-${notification.messageClass}-${notification.type}`
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, renderNotification(notification)))));
};
NCNotification.displayName = 'NCNotification';
export default NCNotification;

//# sourceMappingURL=NCNotification.js.map